export default {
  props: {
    endLabelStyle: {
      type: Object,
      default: () => {
        return {}
      },
    },
    parentClass: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    label: {
      type: String,
    },
    endLabel: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    index: {
      type: [Number, String],
    },
    isBtnEndLabel: {
      type: Boolean,
      default: false,
    },
    endLabelType: {
      type: String,
      default: 'danger',
    },
    onlyRead: {
      type: Boolean,
      default: false,
    },
  },
}
